import * as React from "react";

import classNames from "classnames/bind";
import SmartLink from "common/wrapper/SmartLink";
import type { ResolvedReview } from "resolvers/data/trustpilotResolver";
import dayjs from "utils/dayjs";

import Rating from "../Rating";
import styles from "../Testimonials.module.scss";

const cx = classNames.bind(styles);

interface CardProps extends ResolvedReview {
    prefetch?: boolean;
}

const Card: React.FC<CardProps> = ({
    headline,
    name,
    quote,
    date,
    rating,
    href,
    prefetch = false,
}) => {
    return (
        <SmartLink href={href} prefetch={!!prefetch}>
            <a target="_blank">
                <div className={cx("card")}>
                    <div className={cx("rating")}>
                        <Rating rating={rating} />
                    </div>
                    <div className={cx("details")}>
                        <span className={cx("title")}>{headline || quote}</span>
                        <span className={cx("quote")}>{headline ? quote : ""}</span>
                    </div>
                    <figcaption className={cx("customer")}>
                        {name ? `${name} - ` : ""}
                        {dayjs.utc(new Date(date)).format("dddd D, MMMM YYYY")}
                    </figcaption>
                </div>
            </a>
        </SmartLink>
    );
};

export default Card;
